// Centralised image asset references for EquiSight landing page

export const APP_SCREENSHOTS = [
  {
    name: "Dashboard",
    label: "Dashboard",
    caption: "Eén overzicht voor gezondheid, training en weer.",
    url: "/assets/dashboard.png",
  },
  {
    name: "Login",
    label: "Welkom",
    caption: "Premium ervaring vanaf het eerste scherm.",
    url: "https://customer-assets.emergentagent.com/job_35af8abb-1231-4a38-953c-af1dd3091eef/artifacts/fg76pwz6_image.png",
  },
  {
    name: "Paard detail",
    label: "Paard profiel",
    caption: "Signalen, weer en advies per paard — in detail.",
    url: "https://customer-assets.emergentagent.com/job_35af8abb-1231-4a38-953c-af1dd3091eef/artifacts/a5sz328q_image.png",
  },
  {
    name: "Trainingsschema",
    label: "Trainingsschema",
    caption: "Een week vooruit plannen, dag voor dag.",
    url: "https://customer-assets.emergentagent.com/job_35af8abb-1231-4a38-953c-af1dd3091eef/artifacts/lr0sb1ce_image.png",
  },
];

export const HERO_IMAGE = "/assets/hero-dressage.jpg";

export const PROBLEM_IMAGE =
  "https://images.unsplash.com/photo-1777542450979-8516f4ecf6be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxiZWF1dGlmdWwlMjBob3JzZSUyMGRldGFpbCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzc3NjQ3NzA4fDA&ixlib=rb-4.1.0&q=85";

export const SOCIAL_PROOF_BG =
  "https://images.unsplash.com/photo-1674880944409-38c7a257be8f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwZHJlc3NhZ2UlMjBob3JzZSUyMHJpZGVyJTIwbmF0dXJlfGVufDB8fHx8MTc3NzY0NzcwOXww&ixlib=rb-4.1.0&q=85";

export const WHY_IMAGE =
  "https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=1400&q=80";
